import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SearchCompaniesInput extends Component {
    render() {
        return (
            <div className="input input--search">
                <label htmlFor="companies_search">Søk etter bedrift</label>
                <input
                    className="pam"
                    id="companies_search"
                    onChange={this.props.onSearchInputChange}
                    placeholder="FINN.no for eksempel :)"
                    type="text"
                />
                <div
                    aria-label="Søk"
                    className="input--search__button input--search__button--submit"
                />
            </div>
        );
    }
}

SearchCompaniesInput.propTypes = {
    onSearchInputChange: PropTypes.func,
};

export default SearchCompaniesInput;
